import {IFormData, ILineItemField} from "../../EditInvoice";
import React, {useContext} from "react";
import {AdminContext} from "../../../../../contexts/AdminContext";
import classNames from "../../../../../utils/classNames";
import LineItemRow from "./LineItemRow";
import { SiteProps } from "../../../../../interfaces";


interface MobileLineItemsTableProps {
  resource: IFormData
  items: ILineItemField[]
  isForPrint: boolean
  isPreview: boolean
  site: SiteProps
}

const MobileLineItemsTable = ({ resource, items, isForPrint, isPreview, site }: MobileLineItemsTableProps) => {
  const { camp } = useContext(AdminContext)

  if (isForPrint) {
    return <></>
  }

  return (
      <div
          className={classNames(isPreview ? 'hide-scrollbar-for-preview' : 'hide-scrollbar', 'block custom-500:hidden', !isPreview && 'overflow-y-hidden overflow-x-scroll')}
          style={{ maxWidth: '95vw' }}
      >
        <div style={{ minWidth: !isPreview ? 912 : 'auto' }}>
          <div
              className={classNames(
                  'grid gap-2 font-bold mb-2.5 text-baselg pb-1.5 border-b border-gray-900',
                  isPreview ? 'grid-cols-2' : (resource.is_displaying_occurrences ? 'grid-cols-10' : 'grid-cols-8') + ' md:grid-cols-12'
              )}
          >
            <div className={!isPreview && (resource.is_displaying_occurrences ? "col-span-2 md:col-span-4" : "col-span-2 md:col-span-5")}>Item</div>
            {!isPreview && <div className={'col-span-2'}>Price</div>}
            {!isPreview && resource.is_displaying_occurrences && <div className='col-span-1'>Nights</div>}
            {!isPreview && <div className='col-span-2'>Quantity</div>}
            <div className={!isPreview && 'col-span-2'}>Amount</div>
          </div>
          {items?.map((item, index) => (
              <LineItemRow
                  camp={camp}
                  key={index}
                  index={index}
                  item={{ ...item, is_hidden: isForPrint ? item.unit_amount == 0 : item.is_hidden }}
                  isPreview={isPreview}
                  site={site}
              />
          ))}
        </div>
      </div>
  )
}

export default MobileLineItemsTable;